import {
    CREATE_TWILIO_DEVICE,
    CREATE_TWILIO_TOKEN,
    CREATE_SOCKET_CONNECTION,
    INCOMING_CALL,
    ACCEPT_INCOMING_CALL,
    END_INCOMING_CALL
} from '../actionTypes/caller'

export const initialState = {
    twilioToken: '',
    twilioDevice: null,
    socketConnection: null,
    inboundCall: null,
    callDuration: 0,
    incomingCallReceived: false,
    incomingCall: false
}

const caller = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_TWILIO_DEVICE:
            return {
                ...state,
                twilioDevice: action.data
            }
        case CREATE_TWILIO_TOKEN:
            return {
                ...state,
                twilioToken: action.data
            }
        case CREATE_SOCKET_CONNECTION:
            return {
                ...state,
                socketConnection: action.data
            }
        case INCOMING_CALL:
            return {
                ...state,
                inboundCall: action.data,
                incomingCall: true
            }
        case ACCEPT_INCOMING_CALL:
            return {
                ...state,
                callDuration: action.data,
                incomingCallReceived: true
            }
        case END_INCOMING_CALL:
            return {
                ...state,
                callDuration: 0,
                incomingCallReceived: false,
                inboundCall: null,
                incomingCall: false
            }
        default:
            return state;
    }
}

export default caller